import { Input, Tooltip } from "antd";
import { ReactComponent as QUESTION } from "../../assets/Question.svg";
import { TooltipPlacement } from "antd/es/tooltip";

type BaseInputFieldType = {
  variant?: "outlined" | "borderless" | "filled" | undefined;
  label: string;
  type: string;
  classProps?: string;
  status?: "error" | "warning" | undefined;
  placeholder?: string;
  value?: string | number;
  bg?: string;
  steps?: number;
  onChange: (e: string) => void;
  disabled?: boolean;
  explainText?: {
    palcement?: string;
    text: string;
  };
};

export default function BaseInputField(props: BaseInputFieldType) {
  return (
    <div className={`flex flex-col w-full ${props.classProps}`}>
      <label className="text-sm pl-2 pb-1 flex gap-2">
        {props.label}
        {props.explainText && (
          <Tooltip
            placement={
              (props.explainText.palcement as TooltipPlacement) ?? "topRight"
            }
            arrow={false}
            title={props.explainText.text}
          >
            <QUESTION className="w-5 h-5" />
          </Tooltip>
        )}
      </label>
      <Input
        // required={props.required ?? true}
        onChange={(e) => props.onChange(e.target.value)}
        prefix={<></>}
        status={props.status ?? undefined}
        type={props.type}
        value={props.value}
        disabled={props.disabled}
        placeholder={props.placeholder}
        variant={props.variant}
        rootClassName={"border h-14 rounded-default w-full"}
      />
    </div>
  );
}
